<template>
  <b-alert
    v-if="pass"
    show
    :variant="(pass.isValid) ? 'secondary' : 'danger'"
    class="mb-6"
  >
    <div class="w-full">
      <div class="flex items-center justify-between w-full mb-4">
        <p>{{ $t('general.pass') }}: <strong>{{ pass.name || pass.pass.name }}</strong></p>

        <a @click="removePass"><b-icon icon="x" class="text-secondary" /></a>
      </div>

      <div v-if="pass.isValid">
        <p v-if="pass.infoLabel" class="mb-2" v-html="formatHtml(pass.infoLabel)" />
        <small>{{ $t('components.passDetail.showingValid') }}</small>
      </div>

      <b-button size="sm" variant="action" class="mt-6" @click="removePass">
        {{ $t('components.passDetail.remove') }}
      </b-button>

      <div v-if="!pass.isValid">
        <ul class="list-unstyled">
          <li v-for="error in pass.errors" :key="error">
            {{ error }}
          </li>
        </ul>
      </div>
    </div>
  </b-alert>
</template>

<script>
import Utils from '@/utils'

export default {
  computed: {
    pass() {
      return this.$store.getters['booking/pass']
    }
  },
  methods: {
    removePass() {
      this.$store.dispatch('booking/setPass', null)

      const query = Object.assign({}, this.$route.query)

      if (query.pass) {
        delete query.pass
        this.$router.replace({ query })
      }
    },
    formatHtml (text) {
      return Utils.text.formatHtml(text)
    }
  }
}
</script>
